import { useQuery } from '@apollo/react-hooks';
import { Container, Stack } from '@mui/material';
import gql from 'graphql-tag';
import React, { useEffect } from 'react';

const PRODUCTS = gql`
query {
  availableProducts {
    processor
    id
    label
    pricingOptions {
      planId
      cost
      currency
      billing
      trialDays
    }
    maxPeople
    maxPlaces
    maxQueries
    maxTravels
  }
}
`
;

const INITIATE_PURCHASE = gql`
mutation InitiatePurchase($planId:String!) {
  initiatePurchase(planId:$planId)
}`;

const useScript = url => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url]);
};

const Purchase = props => {
  const {loading, error, data} = useQuery(PRODUCTS, {
    client: props.client
  });

  useScript('https://js.stripe.com/v3/');
  
  if (loading) {
    return "Loading..."
  }

  document.title = 'navscout - Purchase a plan';

  return <Container>
      <h3>Select a Plan</h3>
      <p>All plans come with a 7 day trial period.</p>
      <p>Select a plan to checkout with stripe.</p>
        {
          data.availableProducts.map(p => 
            <Stack key={p.id}>
                <h4>{p.label}</h4>
                <p>
                  Monitored trips: <b>{p.maxTravels}</b><br/>
                  {/* Monthly location reports: <b>{p.maxQueries}</b><br/> */}
                </p>
                  <p>
                  {p.pricingOptions.map(pp => 
                      <button color='blue' onClick={() => checkout(props.client, pp.planId)}>
                          ${pp.cost/100} {pp.currency.toUpperCase()} {period(pp.billing)}
                      </button>
                  )}
                </p>
            </Stack>
          )
        }
      <p>
      A purchase has the following benefits:
      <ul>
        <li>LiveTrack Advisor - Get live updates to weather conditions based on your location</li>
        <li>Add additional stops to your planned route</li>
      </ul>
      </p>
    </Container>;
}

const period = p => {
  return {
    "P1D" : "Daily",
    "P1W" : "Weekly",
    "P1M" : "Monthly",
    "P1Y" : "Yearly"
  }[p]
}

const checkout = (client, planId) => {
  console.log("Checkout "  + planId);
  client.mutate({
    mutation: INITIATE_PURCHASE,
    variables: {planId: planId}
  }).then(data => {
    if (data.data.initiatePurchase === null) {
      console.log('Initiate purchase failed');
    } else {
      const sessionId = data.data.initiatePurchase;
      console.log('Session: ' + sessionId);
      var stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
      stripe.redirectToCheckout({
        sessionId: sessionId
      }).then(result => {
        console.log(result.error.message);
      });
    }
  });
}

export default Purchase;